import React from 'react';
import { Link, graphql } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image";

const Category = props => {
  const colors = props.data.colors.edges;
  const { intro } = props.data;
  const introImageClasses = `intro-image ${intro.frontmatter.intro_image_absolute && 'intro-image-absolute'} ${intro.frontmatter.intro_image_hide_on_mobile && 'intro-image-hide-mobile'}`;

  return (
    <Layout bodyClass="page-services">
      <SEO title="Product Category" />

      
        <div className="container">
          <div className="row justify-content-start">
          { (
              <div className="col-12 col-md-5 col-lg-6 order-1 order-md-2 position-relative">
                <img alt={intro.frontmatter.title} src={intro.frontmatter.intro_image} placeholder="blurred" layout="constrained" width = {500} />
              </div>
            )}
            { (
              <div className="col-12 col-md-5 col-lg-6 order-1 order-md-2 position-relative">
                <img alt={intro.frontmatter.title} src={intro.frontmatter.spec_table} placeholder="blurred" layout="constrained" width = {500} />
              </div>
            )}
          </div>
        </div>
      

      {(
        <div className="container pb-6">
         <div className="row justify-content-start">
          <div className="col-12 col-md-8">
          {intro.frontmatter.title != "Accessories" && (
            <div className="content" dangerouslySetInnerHTML={{ __html: intro.html }} />)}
          </div>
         </div>
        </div>)
      }

    </Layout>
  );
};

export const query = graphql`
  query CategoryQuery($id: String!) {
    intro: markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        intro_image
        spec_table
        details_path
      }
      fields {
        slug
      }
      html
    }

    colors: allFile (filter: { relativeDirectory: { eq: "colors" } }) {
      edges {
        node {
          id
          childImageSharp {
            gatsbyImageData(
              width: 200
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    }
  }
`;

export default Category;
